import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Button,
  Input,
  UncontrolledCollapse,
  CardBody,
  Row,
  Col,
  Card,
  Badge,
  Table,
  Tooltip,
  FormGroup,
} from "reactstrap";
import {
  GET_LICENSE_TEMPLATE,
  UPDATE_LICENSE,
  AGENCY_LIST,
} from "../../../constants/ApiPaths";
import { debounce } from "underscore";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import Pagination from "react-js-pagination";
import Swal from "sweetalert2";
import { useSnackbar } from "notistack";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { useFormik } from "formik";
import Select from "react-select";
import * as Yup from "yup";
import { getAdminUserId } from "../../common/CommonFunctions";
import { Info } from "../../common/Info";
import { Link } from "react-router-dom";

const statusstyle = {
  Approved: "success",
  Pending: "warning",
  Rejected: "danger",
};

export default function AgencyTemplates() {
  const [list, setlist] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [currentpage, setCurrentPage] = useState(0);
  let statusD=''
  let agencyName=''
  let rowperpage=10;
  const [count, setcount] = useState(0);
  const [options, setoptions] = useState([]);

  const { enqueueSnackbar } = useSnackbar();
  const [totalrecords, setTotalRecords] = useState(0);
  const [selectagency, setselectagency] = useState("");
  const [agencyId, setagencyId] = useState("");

  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };

  useEffect(() => {
    getAgency();
  }, []);

  useEffect(() => {
    gettemplate(agencyName);
  }, [currentpage, count]);

  let getAgency = async (selectagency) => {
    const config = {
      method: "GET",
      url: AGENCY_LIST,
      headers: authHeader(),
      params: {
        count: 10,
        agencyName: selectagency,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setoptions(
          data.map((d) => ({ value: d.agencyId, label: d.agencyName }))
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };
  const gettemplate = async (agencyId) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_LICENSE_TEMPLATE,
      headers: authHeader(),
      params: {
        offset: currentpage,
        count: rowperpage,
        agencyId: agencyId,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setlist(data);
        setTotalRecords(totalCount);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
 

  let ChangeStatus = (i) => {
    const st = i.templateStatus;
    if (st === "Pending") {
      return (
        <Input
          onChange={(e) => templatecomment(e, i)}
          type="select"
          name="Status"
          value={statusD}
        >
          <option value="">Change Status</option>
          <option value="Approved">Approve</option>
          <option value="Rejected">Reject</option>
        </Input>
      );
    }
  };

  let templatecomment = async (e, i) => {
    const Id = i.templateId;
    const Value = e.target.value;
    if (Value === "Rejected") {
      const { value: text } = await Swal.fire({
        title: "Reason for Reject",
        input: "text",
        showCancelButton: true,
        allowOutsideClick: false,
        inputPlaceholder: "Enter Reason for Reject ",
        inputValidator: (value) => {
          if (!value) {
            return "Please enter the reason for Reject";
          }
        },
      });
      if (text) {
        RejectStatus(Value, Id, text);
      }
      // toggle()
    } else if (Value === "Approved") {
      Swal.fire({
        title: "Are you sure?",
        text: "Are You Want to Approve this Licence!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve!",
      }).then((result) => {
        if (result.isConfirmed) {
          RejectStatus(Value, Id);
        }
      });
    }
  };

  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };

  let RejectStatus = async (text, Id, Value) => {
    setLoading(true);
    const config = {
      method: "PUT",
      url: UPDATE_LICENSE,
      headers: authHeader(),
      data: {
        templateId: Id,
        templateComments: Value,
        hyperlink: `${window.location.origin}${"/agency/template"}`,
        approvedBy: getAdminUserId(),
        status: text,
      },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        setcount(count + 1);
        setLoading(false);
        CustomAlertMessage(
          "License" +
            (text === "Rejected" ? " Reject " : " Approved ") +
            "Sucessfully!",
          "success",
          enqueueSnackbar
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const validationSchema = Yup.object({
    templateComments: Yup.string().required("Comments is required!"),
  });

  const {
    
  } = useFormik({
    enableReinitialize: true,
    onSubmit: (values) => {
      RejectStatus(values);
    },
    validationSchema,
  });

  const delaySearch = useRef(
    debounce((agencyId) => gettemplate(agencyId))
  ).current;

  useEffect(() => {
    //callList();
    delaySearch(agencyId);
  }, [agencyId]);

  let OptionHandle = (e) => {
    if (e !== null) {
      const { value } = e;
      setCurrentPage(0);
      setagencyId(value);
    } else {
      setselectagency("");
      setagencyId("");
      setCurrentPage(0);
    }
  };
  let OptionInputHandle = (text) => {
    setselectagency(text);
  };

  const AgencySearch = useRef(
    debounce((selectagency, agencyId) => getAgency(selectagency, agencyId))
  ).current;

  useEffect(() => {
    //callList();
    AgencySearch(selectagency, agencyId);
  }, [selectagency, agencyId]);

  return (
    <div>
      {Loading && <CustomPageLoading />}
      <div className="wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>
              Templates
              <Tooltip
                isOpen={id === "templates" && tooltipOpen}
                target={"templates"}
                toggle={() => toggle("templates")}
              >
                View template Details
              </Tooltip>
              <span id={"templates"}>
                <Info />
              </span>
            </h4>

            <div className="top-btn">
              <Button color="link" id="toggler">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14.371"
                  height="14.371"
                  viewBox="0 0 14.371 14.371"
                >
                  <path
                    id="Icon_awesome-filter"
                    data-name="Icon awesome-filter"
                    d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                    fill="#1b3e6f"
                  />
                </svg>
              </Button>
            </div>
          </div>

          <UncontrolledCollapse className="mt-4" toggler="#toggler">
            <Card>
              <CardBody>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <span>Select Agency</span>
                      <Select
                        options={options}
                        isClearable={true}
                        placeholder="Select Agency"
                        onChange={OptionHandle}
                        onInputChange={OptionInputHandle}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </UncontrolledCollapse>

          <Card body className="mt-4">
            <Table hover responsive className="space-pre">
              <thead>
                <tr>
                  <th>Licence Name</th>
                  <th>Agency Name</th>
                  <th>Customer Portal URL</th>
                  <th>Status</th>
                  <th>Active</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Loading ? (
                  ""
                ) : list.length === 0 ? (
                  <tr>
                    <td colSpan={6}>
                      <center>No Records Found</center>
                    </td>
                  </tr>
                ) : (
                  <>
                    {list.map((i) => {
                      return (
                        <tr key={i}>
                          <td>{i.licenseName}</td>
                          <td>{i.agencyName}</td>
                          <td>
                            {" "}
                            <a
                              href={
                                `${window.location.origin}` +
                                "/customer/" +
                                `${i.agencyUrl}`
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              {window.location.origin}/customer/{i.agencyUrl}
                            </a>
                          </td>
                          <td>
                            <Badge color={statusstyle[i.templateStatus]}>
                              {i.templateStatus}
                            </Badge>
                          </td>
                          <td>
                            <Badge color={i.isActive ? "info" : "danger"}>
                              {i.isActive ? "Active" : "In Active"}
                            </Badge>
                          </td>
                          <td>
                            <div className="template-action d-flex">
                              {/* <Link
                                to={{
                                  pathname: "/admin/agency",
                                }}
                              >
                                <Button size="sm" color="primary">
                                  See all
                                </Button> */}
                              {/* </Link> */}
                              {ChangeStatus(i)}
                              <Link
                                to={{
                                  pathname: `/admin/templatedetails/${i.templateId}`,
                                }}
                                state={{ status: i.templateStatus }}
                              >
                                {" "}
                                <Button
                                  data-templated={i.templateId}
                                  className="table-btn"
                                  color="link"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16.216"
                                    height="10.811"
                                    viewBox="0 0 16.216 10.811"
                                  >
                                    <path
                                      id="Icon_awesome-eye"
                                      data-name="Icon awesome-eye"
                                      d="M16.118,9.494A9.03,9.03,0,0,0,8.108,4.5,9.031,9.031,0,0,0,.1,9.495a.911.911,0,0,0,0,.822,9.03,9.03,0,0,0,8.01,4.994,9.031,9.031,0,0,0,8.01-4.995A.911.911,0,0,0,16.118,9.494Zm-8.01,4.465a4.054,4.054,0,1,1,4.054-4.054A4.054,4.054,0,0,1,8.108,13.959Zm0-6.757a2.683,2.683,0,0,0-.713.107A1.347,1.347,0,0,1,5.512,9.193a2.7,2.7,0,1,0,2.6-1.99Z"
                                      transform="translate(0 -4.5)"
                                      fill="#1b3e6f"
                                    />
                                  </svg>
                                </Button>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                )}
              </tbody>
            </Table>
            <div className="d-flex flex-row py-4 justify-content-end">
              <Pagination
                itemClass="page-item"
                linkClass="page-link"
                activePage={currentpage + 1}
                itemsCountPerPage={rowperpage}
                totalItemsCount={totalrecords}
                onChange={onPageChange}
              />
            </div>
          </Card>
        </Container>
      </div>
    </div>
  );
}
